import { combineReducers } from 'redux';
import broadband from './broadband';
import loan from './loan';
import akasse from './akasse';
import cellphone from './cellphone';
import tv from './tv';
import mbb from './mbb';
import webhotel from './webhotel';
import vpn from './vpn';
import mealbox from './mealbox';
import streaming from './streaming';

const reducer = combineReducers({
  // routing: routeReducer,
  broadband,
  loan,
  akasse,
  cellphone,
  tv,
  mbb,
  webhotel,
  vpn,
  mealbox,
  streaming
});

export default reducer;
